import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { StringUtilities } from '@app/utilities/string-utilities';
import { PersonPortalState } from '@app/models/person-portal-state';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';
import { EmailTemplate } from '@app/models/email-template';
import { EmailTemplateCodes } from '@app/utilities/email-template-codes';
import { AuthorizationService } from '@app/services/authorization.service';

@Injectable({
  providedIn: 'root'
})
export class AdminEmailService {

  constructor(private authorizationService: AuthorizationService,) { }

  public sendAdminEmail(subject: string, accountNum?: string, userId?: string): void {    
    this.authorizationService.sendEmailToAdmin(subject, accountNum, userId)
      .subscribe({
        next: (status: any) => {
         
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
        }
      })
  }
}
